import React from "react";
import {
  Row,
  Col,
  TabPane,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Pagination from "rc-pagination";
import SharedComponent from "../Shared";
import Moment from "react-moment";
import { Api } from "../../../Api/index";
class PilotFeedback extends SharedComponent {
  state = {
    dropdownOpen: false,
    activeTab: "ScheduledM",
    inputVal: this.props.inputValue,
    isLoading: true,
    data: {
      ApplicationNumber: "",
      CreatedAt: "",
      comment: "",
      status: "",
    },
    items: [],
    requestOptions: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      pageSize: 20,
    },
    modal: false,
    Status: [{ name: "New" }, { name: "Closed" }],
  };
  async componentDidMount() {
    this.queryItems();
  }

  render() {
    const { isLoading, items, data, Status } = this.state;
    const { currentPage, pageSize, totalItems } = this.state.requestOptions;
    return (
      <TabPane tabId="PilotFeedback">
        <Form className="mb-3 mt-3" onSubmit={this.handleSubmit}>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Label for="ApplicationNumber">Application Number</Label>
                <Input
                  type="text"
                  name="ApplicationNumber"
                  id="ApplicationNumber"
                  onChange={this.handleChange}
                  value={data.ApplicationNumber}
                />
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label for="CreatedAt">Date</Label>
                <Input
                  type="date"
                  name="CreatedAt"
                  id="CreatedAt"
                  onChange={this.handleChange}
                  value={data.CreatedAt}
                />
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label for="status">Status</Label>
                <Input
                  type="select"
                  name="status"
                  id="status"
                  value={data.status}
                  onChange={this.handleChange}
                >
                  <option selected>Select Status</option>
                  {Status.map((option) => (
                    <option key={option.name} value={option.name}>
                      {option.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <div
                  style={{ height: 30 }}
                  className="d-none d-md-block d-lg-block"
                ></div>
                <Button type="submit" color={"info"} className="w-100">
                  Search
                </Button>
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <div
                  style={{ height: 30 }}
                  className="d-none d-md-block d-lg-block"
                ></div>
                <Button
                  color={"success"}
                  onClick={this.resetData}
                  className="w-100"
                >
                  Reset Data
                </Button>
              </FormGroup>
            </Col>
          </Row>
        </Form>

        {!isLoading ? (
          <React.Fragment>
            {items.length !== 0 ? (
              <React.Fragment>
                <Row>
                  <Col md={12}>
                    <Table className="table table-bordered table-striped table-hover mb-4">
                      <thead>
                        <tr>
                          <th className="sort-alpha">Application Number</th>
                          <th className="sort-alpha">Client Name</th>
                          <th className="sort-alpha">Client Phone</th>
                          <th className="sort-alpha">Car Make</th>
                          <th className="sort-alpha">Car Model</th>
                          <th className="sort-alpha">Date</th>
                          <th className="sort-alpha">Comment</th>
                          <th className="sort-alpha">Status</th>
                          <th className="sort-alpha">Control</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.map((item) => (
                          <tr key={Math.random()}>
                            <td>{item.applicationNumber}</td>
                            <td>{item.clientName}</td>
                            <td>{item.clientPhone}</td>
                            <td>{item.carMake}</td>
                            <td>{item.carModel}</td>
                            <td>
                              <Moment format="MM/DD/YYYY">
                                {item.createdAt}
                              </Moment>
                            </td>
                            <td>{item.comment}</td>
                            <td>
                              <div className="badge badge-success ">
                                {item.status}
                              </div>
                            </td>
                            <td className="text-center">
                              <div>
                                <Button
                                  onClick={() => this.openModel(item.id)}
                                  color="warning"
                                  className="btn btn-warning d-inline-flex align-items-center"
                                >
                                  Details
                                </Button>
                                <Button
                                  onClick={() =>
                                    this.handleClose(item.id, "close")
                                  }
                                  color="danger"
                                  className="btn  d-inline-flex align-items-center mx-1"
                                >
                                  Close
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Pagination
                      showSizeChanger
                      defaultPageSize={pageSize}
                      defaultCurrent={currentPage}
                      onChange={this.handlePageChange}
                      total={totalItems}
                      className="float-right text-white"
                    />
                  </Col>
                </Row>
              </React.Fragment>
            ) : (
              this.renderSadFace(true)
            )}
          </React.Fragment>
        ) : (
          this.renderLoader()
        )}

        <Modal isOpen={this.state.viewModel} toggle={this.closeViewModel}>
          <ModalHeader toggle={this.toggleModal}>Feedback Tickets</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label>Comment</Label>
                <Input
                  type="textarea"
                  name="comment"
                  onChange={this.handleChange}
                  value={data.comment}
                  rows={5}
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.closeViewModel}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </TabPane>
    );
  }

  openModel = (id) => {
    this.setState({ viewModel: true });
    Api.Notifications.PilotFeedback.FeedBackDetails(id)
      .then((data) => this.setState({ data }))
      .catch((error) => {
        this.renderErrorAlert("Ops!", `${error.response.data.Message}`);
      });
  };

  closeViewModel = () => {
    this.setState({ viewModel: false });
  };

  queryItems = (page) => {
    this.setState({
      isLoading: true,
    });
    const { pageSize, currentPage } = this.state.requestOptions;
    const { ApplicationNumber, CreatedAt, status } = this.state.data;
    Api.Notifications.PilotFeedback.PilotFeedbackList(
      ApplicationNumber,
      CreatedAt,
      page,
      currentPage,
      pageSize,
      status
    )
      .then((response) => {
        let items = response.items;
        this.setState({
          isLoading: false,
          items,
          requestOptions: {
            currentPage: response.currentPage,
            totalPages: response.totalPages,
            totalItems: response.totalItems,
            pageSize: response.pageSize,
          },
        });
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        console.log(error);
      });
  };
  doSubmit = () => {
    this.queryItems(1);
  };
  resetData = () => {
    const requestOptions = this.state.requestOptions;
    const data = this.state.data;
    requestOptions.currentPage = 1;
    requestOptions.totalPages = 1;
    requestOptions.totalItems = 0;
    requestOptions.pageSize = 20;
    data.ApplicationNumber = "";
    data.CreatedAt = "";
    data.status = "";
    this.setState({ requestOptions, data });
    this.queryItems();
  };
  handleClose = (id, Case) => {
    Api.Notifications.PilotFeedback.CloseFeedBack(id, Case)
      .then(() => {
        this.renderSuccessAlert("The request is close", "Click the button");
        this.queryItems(1);
      })
      .catch((error) => {
        this.renderErrorAlert("Ops!", `${error.response.data.Message}`);
      });
  };
}

export default PilotFeedback;
